import StyledLink from '../StyledLink'
import {
  MONITOR,
  RESULTS
} from '../routes'
import type { Props } from '../types'

interface Params {
  isSubmodel?: boolean
  runId: number
}

const base = '/' + MONITOR + '/' + RESULTS

const LinkToMonitorResultView = ({
  children,
  isSubmodel = false,
  runId,
  isHyperlink
}: Props & Params) => {
  const subModel = isSubmodel
    ? '?isSubmodel'
    : ''

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={`${base}/${runId}${subModel}`}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToMonitorResultView
